import {
  FETCH_ORDER_LIST,
  FETCH_ORDER,
  FETCH_CUSTOM_ORDER,
  SAVE_ORDER_DATA,
  SAVE_CUSTOM_ORDER_DATA,
  SAVE_TOUR_ORDER_DATA,
} from '../mutation-types'

const initialState = {
  order: [],
  currentOrder: null,
  customOrder: {},
  customOrderData: {
    customId: 0,
    sportsTourRouteId: 0,
    personCount: 2,
    selectedServices: [],
    contactInfo: {
      id: '',
      name: null,
      mobile: null,
    },
    departureStart: null,
    departureEnd: null,
    remark: null,
  },
  tourOrder: {},
  tourOrderData: {
    tourId: 0,
    personCount: 1,
    contactInfo: {
      id: '',
      name: null,
      mobile: null,
    },
  },
  orderData: {
    needNumber: null,
    realNameInfo: [{}],
    attn: {
      id: '',
    },
    selectedAddress: {
      name: '',
      areaName: '',
      id: '',
      mobile: '',
      detailAddress: '',
    },
    selected: {
      number: 1,
      scene: null,
      ticket: null,
      county: [],
      detailAddress: '',
    },
    passportInfo: {
      cnRealName: '',
      enFirstName: '',
      enLastName: '',
      passportNo: '',
    },
    contactEmail: '',
    contactIdNo: '',
  },
}

const mutations = {
  [FETCH_ORDER_LIST](state, data) {
    state.order = data.orders
  },

  [FETCH_ORDER](state, data) {
    state.currentOrder = data
  },

  [FETCH_CUSTOM_ORDER](state, data) {
    state.customOrder = data
  },

  [SAVE_ORDER_DATA](state, data) {
    state.orderData = data
  },

  [SAVE_CUSTOM_ORDER_DATA](state, data) {
    state.customOrderData = data
  },

  [SAVE_TOUR_ORDER_DATA](state, data) {
    state.tourOrderData = data
  },
}

export default {
  state: initialState,
  mutations,
}



// WEBPACK FOOTER //
// ./client/vuex/modules/order.js